// extracted by mini-css-extract-plugin
module.exports =  {"header":"e3afc254ff--header--VIfv0","title":"e3afc254ff--title--agYwL"};